import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { PLUS_UPDATE_PAYMENT_SUCCESS } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_PLUS_MAIN_PAGE } from 'apps/auth/constants/UrlConstants';

const Success = (props) => {
    useEffect(() => {
        if (props.paymentMethodUpdated) {
            amplitude.getInstance().logEvent(PLUS_UPDATE_PAYMENT_SUCCESS);
        }
    }, []);

    const renderScreen = () => {
        return (
            <InfoPage
                animatedIconSuccess
                hasBorder={false}
                mainText={props.headerTitle}
                buttonRowCaption={null}
                primaryButtonCaption={props.statusDoneTitle}
                primaryButtonType="link"
                primaryButtonLink={AUTH_PLUS_MAIN_PAGE}
            />
        );
    };

    return renderScreen();
};

const mapStateToProps = (state) => {
    return {
        headerTitle: state.messages.pageMessages.headerTitle,
        statusDoneTitle: state.messages.pageMessages.statusDoneTitle,
        paymentMethodUpdated: state.extra?.paymentMethodUpdated,
    };
};

export default connect(mapStateToProps, null)(Success);
